module.exports = __webpack_public_path__ + "static/media/58pic.026c8618.jpg";